import { io } from 'socket.io-client'
import axios from 'axios'
import _ from 'lodash'
import _watcheebox from '../components/watcheebox/watcheebox.js'
import router from '../router'
import VueCookie from 'vue-cookie'
// import store from '../store'

export default {
  install (Vue, { store }) {
    Vue.use(VueCookie)
    console.log('install socket dans le store : ', store)
    let loadBalancerSocket = 'https://lb-sw-prod.watcheebox.net' // pour la PROD
    // si on est en dev
    if (process.env.NODE_ENV === 'development') {
      loadBalancerSocket = 'https://lb-sw-moon-dev-v2.watcheebox.net' // pour la PROD
      // loadBalancerSocket = 'https://node-dev-01.watcheebox.net/' // pour la DEV
    } else if (process.env.NODE_ENV === 'preprod') {
      loadBalancerSocket = 'https://lb-sw-moon-preprod-v2.watcheebox.net' // pour la PREPROD
    // sinon c'est de la production
    } else {
      loadBalancerSocket = 'https://lb-sw-prod.watcheebox.net/' // pour la PROD
    }
    console.log('loadBalancerSocket :', loadBalancerSocket)
    const socket = io(loadBalancerSocket, {
      secure: true,
      transports: ['websocket', 'polling'],
      timeout: 25000, // 5 seconds should be enough
      reconnection: true,
      reconnectionDelayMax: 8000,
      reconnectionDelay: 5000,
      autoConnect: false,   // ❗ NE PAS se connecter tant qu'on n'a pas login
      reconnectionAttempts: 1000
    })
    // socket.connect() // Se connecter au socket

    // ⬅️ IMPORTANT : on enregistre la socket dans le store
    // store.commit('_StoreWatcheeBox/SET_SOCKET_INSTANCE', socket)

    // Ajouter le socket à Vue prototype pour accès global via this.$socket
    Vue.prototype.$socket = socket

    // Centraliser l'écoute des événements ici
    // socket.on('connect', () => {
    //   console.log('✅ Connecté au serveur Socket.io')
    // })

    /**
     * Message de retour 'connect' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('connect', async () => {
      console.log('⚡ socket connect detected')

      // attendre que le store soit prêt
      let retry = 0
      // eslint-disable-next-line no-unmodified-loop-condition
      while ((!store.getters['_User/user'] || !store.state._StoreWatcheeBox.sessionPHP) && retry < 200) {
        // eslint-disable-next-line promise/param-names
        await new Promise(res => setTimeout(res, 20)) // 20ms * 200 = 4 secondes max
        retry++
      }

      const user = store.getters['_User/user']

      if (!user) {
        console.error('❌ User non chargé → connexionAgent NON APPELÉ')
        return
      }

      console.log('🟢 User OK → Connexion agent')

      store.dispatch('_StoreWatcheeBox/stopSocketReconnectLoop')
      store.commit('_StoreWatcheeBox/SOCKET_CONNECT_CLIENT')
      store.dispatch('_StoreWatcheeBox/connectSocket', socket)

      const finalUser = _.cloneDeep(user)

      const statusManually = store.state._StoreWatcheeBox.statusManually
      finalUser.status = statusManually || finalUser.status

      const storageKeyWebPush = localStorage.getItem('server-keys')
      const storageSubscriptionWebPush = localStorage.getItem('server-subscription')

      _watcheebox.connexionAgent({
        agentStatus: finalUser.status,
        datasAgent: finalUser,
        agentName: store.getters['_User/fullName'],
        sessionPHP: store.state._StoreWatcheeBox.sessionPHP,
        keyWebPush: storageKeyWebPush,
        subscriptionWebPush: storageSubscriptionWebPush
      })

      _watcheebox.changeStatusAgent({
        statut: finalUser.status,
        agentID: finalUser.id,
        sessionsPrivees: store.state._StoreWatcheeBox.sessionsPrivees,
        roomName: finalUser.entKey,
        sessionPHP: store.state._StoreWatcheeBox.sessionPHP
      })
    })

    /**
     * Message de retour 'disconnect' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('disconnect', (message) => {
      console.log('❌ socket disconnect : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_DISCONNECT_CLIENT')
        store.commit('_StoreWatcheeBox/SET_CONNECTED', false)
        // ➜ Démarrer la boucle de reconnexion
        store.dispatch('_StoreWatcheeBox/startSocketReconnectLoop', socket)
        // socket.connect()
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'event' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('event', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_EVENT')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'sys_message' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('sys_message', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_SYS_MESSAGE')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'connecting' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('connecting', (message) => {
      console.log('❌ socket connecting : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_CONNECTING')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'connect_failed' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('connect_failed', (message) => {
      console.log('❌ socket connect_failed : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_CONNECT_FAILED')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'close' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('close', (message) => {
      console.log('❌ socket close : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_CLOSE')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'reconnect' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('reconnect', (attempt) => {
      console.log('🔄 Reconnecté après', attempt, 'tentatives')
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SET_CONNECTED', true)
        // Très important : relancer ton workflow
        // store.dispatch('_StoreWatcheeBox/global_connectAgent')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'reconnecting' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('reconnecting', (message) => {
      console.log('❌ socket reconnecting : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_RECONNECTING')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })
    // Erreur de reconnexion
    socket.on('reconnect_error', (err) => {
      console.error('❌ Erreur de reconnexion :', err.message)
    })

    /**
     * Message de retour 'reconnect_failed' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('reconnect_failed', (message) => {
      console.log('❌ socket reconnect_failed : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_RECONNECT_FAILED')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'reconnect_attempt' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('reconnect_attempt', (message) => {
      console.log('❌ socket reconnect_attempt : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_RECONNECT_ATTEMPT')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'lastSocketDisconnected' du server socket.io
     * message retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('lastSocketDisconnected', (message) => {
      console.log('❌ socket lastSocketDisconnected : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_LAST_SOCKET_DISCONNECTED')
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'error' du server socket.io
     * erreur retour serveur
     * @param  {Object} message [message agent]
    */
    socket.on('error', (message) => {
      console.log('❌ socket error : ', message)
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_ERROR_MESSAGE', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'noAutorisationConnexion' du server socket.io
     * pas autorisé à ce connecter au server
     * @param  {Object} message [message agent]
    */
    socket.on('noAutorisationConnexion', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_NO_AUTORISATION_AGENT', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'logoutOldAgent' du server socket.io
     * déconnexion de vieux agent
     * @param  {Object} message [message agent]
    */
    socket.on('logoutOldAgent', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_DELOG_OLD_SESSION', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'autoLogoutAgent' du server socket.io
     * déconnexion auto de l'agent
     * @param  {Object} message [message agent]
    */
    socket.on('autoLogoutAgent', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_AUTO_DELOG_SESSION', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'myInfos' du server socket.io
     * avec les nouvelles infos agent
     * @param  {Object} message [message agent]
    */
    socket.on('myInfos', (message) => {
      console.log('✅ Agent Connecté au serveur Socket.io', message)
      if (store) {  // Vérifier que le store est bien disponible
        // console.log('store', store)
        // mise à jour du store _StoreWatcheeBox avec les nouvelles données
        store.commit('_StoreWatcheeBox/SOCKET_INFOS_AGENT', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
      _watcheebox.changeStatusAgent({
        statut: store.state._StoreWatcheeBox.status,
        agentID: store.state._User.id,
        sessionsPrivees: store.state._StoreWatcheeBox.sessionsPrivees,
        roomName: store.state._User.entKey,
        sessionPHP: store.state._StoreWatcheeBox.sessionPHP
      })
    })

    /**
     * Message de retour 'updatePresenceAgent' du server socket.io
     * met à jour la liste des agents
     * @param  {Object} message [message agent]
    */
    socket.on('updatePresenceAgent', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // console.log('updatePresenceAgent', message)
        // mise à jour du store _StoreWatcheeBox avec les nouvelles données
        // store.commit('_StoreWatcheeBox/SOCKET_INFOS_AGENT', message)
        var myStatus
        _.forEach(
          message.presenceAgent,
          (agent, key) => {
            if (agent[2] === store.state._User.id) {
              // console.log('agent deja dans le tableau ', store.state._User.id)
              myStatus = agent[3] // mon nouveau status (offline/online/busy)
              if (agent[4] !== store.state._StoreWatcheeBox.mySocketID) {
                // console.log('pas le même socketID')
                // il faut tester ici la sessionPHP
                // si c'est la meme session
                let sessionPHP = new Vue().$cookie.get('PHPSESSID').slice(0, 10) // sa sessionPHP
                // le multissession ne s'applique pas à une connexion freshdesk
                // console.log('sessionPHP :' + sessionPHP + '=== agent[22] ' + agent[22])
                if (sessionPHP === agent[22]) {
                  // console.log('mais la même sessionPHP')
                  // multi connexions sur le même navigateur
                  // store.commit('_StoreWatcheeBox/MULTICONNEXIONS_AGENT',
                  //   {
                  //     'mySocketID': store.state._StoreWatcheeBox.mySocketID,
                  //     'PHPSessionID': agent[22]
                  //   }
                  // )
                } else {
                  console.log('mais pas la même sessionPHP')
                }
              }
            }
          }
        )
        // commit dans le store les nouvelles données
        store.commit('_StoreWatcheeBox/SOCKET_LISTE_AGENTS', {
          status: myStatus,
          listeAgents: message.presenceAgent,
          chatAgent: message.chatAgent
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'debloqueOK' du server socket.io
     * pour debloquer l'agent en multisessio
     * @param  {Object} message [message agent]
    */
    socket.on('debloqueOK', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_DEBLOQUE_MULTISESSION', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updatePresenceVisiteurs' du server socket.io
     * pour recuperer les infos visiteurs
     * @param  {Object} message [message agent]
    */
    socket.on('updatePresenceVisiteurs', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        console.log('updatePresenceVisiteurs', message)
        // console.log('updatePresenceVisiteurs clientsListOnline', message.clientsListOnline)
        // var messageData = JSON.parse(message) // message est en string ?? --> parse en json le message
        // console.log('updatePresenceVisiteurs', messageData.clientsListOnline)
        store.commit('_StoreWatcheeBox/SOCKET_LISTE_VISITEURS', {
          listeVisiteurs: message.clientsListOnline, // liste des visiteurs
          listAllSiteID: _.map(store.state._Sites.sites, 'LIC_ID') // tableau des siteID de l'agent
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'changeSocketID' du server socket.io
     * l'utilisateur change de socketID
     * @param  {Object} message [message agent]
    */
    socket.on('changeSocketID', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_CLIENT_CHANGE_SOCKETID', {
          newSocketID: message.data.socketID, // nouveau socketID du client
          listeSocketID: message.listeSocketID || [message.data.socketID], // liste des socketID dispo pour ce client
          clientID: message.data.chatSession // identification du client
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updateListeSocketIDVisiteur' du server socket.io
     * l'utilisateur update sa liste de socketID
     * @param  {Object} message [message agent]
    */
    socket.on('updateListeSocketIDVisiteur', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // console.log('socket_updateListeSocketIDVisiteur :', message)
        store.commit('_StoreWatcheeBox/SOCKET_CLIENT_CHANGE_SOCKETID', {
          clientID: message.visiteurID, // id du visiteur
          listeSocketID: message.listeSocketID || [message.cibleSocketID] // liste des socketID dispo pour ce client
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'leaveVisitor' du server socket.io
     * lle visiteur quit la room
     * @param  {Object} message [message agent]
    */
    socket.on('leaveVisitor', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // mettre le socketID du visiteur à 0 dans la liste des visiteurs
        store.commit('_StoreWatcheeBox/SOCKET_LEAVE_VISITEURS', {
          newSocketID: message.data.clientSocketID, // nouveau socketID du client
          clientID: message.data.chatSession // identification du client
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updateMyPresence' du server socket.io
     * l'utilisateur update sa presence dans la room'
     * @param  {Object} message [message agent]
    */
    socket.on('updateMyPresence', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        var newTabClient = message.myPresence.split(',')
        var newDataFiltrage = JSON.parse(message.dataFiltrage)
        // recupere les infos du nouveau visiteur
        store.commit('_StoreWatcheeBox/SOCKET_NEW_VISITEUR', {
          newVisiteur: newTabClient, // nouveau client avec ses données
          dataFiltrage: newDataFiltrage, // les données du filrtage visiteur
          listeSocketID: message.listeSocketID || [message.cibleSocketID], // liste des socketID dispo pour ce client
          entId: store.state._User.entId, // entrepriseID de l'agent,
          maxVisitors: store.state._User.maxVisitors,
          listAllSiteID: _.map(store.state._Sites.sites, 'LIC_ID') // tableau des siteID de l'agent
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updatechatRoomClient' du server socket.io
     * mise à jour de la room
     * @param  {Object} message [message agent]
    */
    socket.on('updatechatRoomClient', (message) => {
      console.log('updatechatRoomClient', message)
      if (store) {  // Vérifier que le store est bien disponible
        // recupere les infos du nouveau visiteur
        store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_ROOM', {
          messageChat: message.data // les données updateChat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'saveStreamToHistochat' du server socket.io
     * enregistre le message dans l'hitorique de chat
     * @param  {Object} message [message agent]
    */
    socket.on('saveStreamToHistochat', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // recupere les infos du nouveau visiteur
        store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_ROOM', {
          messageChat: message.data // les données updateChat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updatechatClient' du server socket.io
     * Reception d'un message visiteur envoyé directement à un agent
     * @param  {Object} message [message agent]
    */
    socket.on('updatechatClient', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // uniquement si l'agent est online ou occupé
        console.log('socket_updatechatClient', message)
        if (store.state._StoreWatcheeBox.status === 'online' || store.state._StoreWatcheeBox.status === 'busy') {
          console.log('je suis en ligne')
          // requête log des messages recu
          // console.log(message)
          let debug = null
          if (debug) {
            // console.log(message)
            let dataToPost = new window.FormData()
            dataToPost.append('idVisitor', message.data.chatSession)
            dataToPost.append('message', message.data.message)
            dataToPost.append('agentid', message.data.WZAgentId)
            dataToPost.append('type', 'updateChat')
            dataToPost.append('siteId', message.data.siteId)
            dataToPost.append('entId', message.data.entrepriseId)
            axios.post('post/log_update_send.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then(response => {})
          }
          // check si ce visiteur est deja en session chat avec moi
          // console.log('state.sessionsPrivees.length', state.sessionsPrivees.length)
          // console.log ('chatMax', context.rootState._User.chatsMax)
          var indexSession = _.findIndex(store.state._StoreWatcheeBox.sessionsPrivees, [
            1,
            message.data.chatSession
          ])
          // si pas en session chat, alors c'est un premier message
          // on va rechercher si il n'y a pas deja un historique de chat avec moi
          if (indexSession === -1) {
            // --------------- DEMANDE HISTORIQUE DE CHAT
            _watcheebox.firstLoadHistoChat(
              {
                chatSession: message.data.chatSession,
                entrepriseId: message.data.entrepriseId
              }
            )
            .then(histoChat => {
              console.log('firstLoadHistoChat --> histoChat', histoChat)
              console.log('firstLoadHistoChat --> message;data', message.data)
              // Si c'est un message de type '18' d'un bot
              // on l'ajoute à l'historique car il n'est pas stocké en base
              if (message.data.messageType === 18) {
                // affichage du premier message qui indique le transfere du bot
                let messageBot = {
                  'attachments': message.data.attachments,
                  'auteur': 'Notification',
                  'chatSession': '0',
                  'message': message.data.message,
                  'nameAuteur': message.data.nameAuteur,
                  'timestamp': message.data.timeStamp,
                  'type': message.data.messageType,
                  'visiteurId': message.data.chatSession,
                  'histoChatBot': message.data.histoChatBot,
                  'agentId': message.data.WZAgentId
                }
                histoChat.push(messageBot)

                // construction de l'historique de chat avec le bot
                let histoDom = message.data.histoChatBot
                let parser = new DOMParser()
                let elemDom = parser.parseFromString(histoDom, 'text/html')
                let body = elemDom.lastChild.lastChild.childNodes
                // console.log('body', body)
                // recherche dans l'historique de chat avec le bot
                listChildNodes({
                  messageData: message.data, // les données updateata
                  node: body // le noeud à parcourir
                })
              }

              // parcoure le noeud
              function listChildNodes (data, retour) {
                console.log('data', data.node)
                let body = data.node
                body.forEach(
                  function (currentValue, currentIndex, listObj) {
                    // si message bot
                    if (currentValue.classList.contains('WZagent-Bot') || currentValue.classList.contains('botImageAndLabel')) {
                      // ajoute le message dans l'historique
                      addMessage({
                        messageData: data.messageData, // les données updateata
                        currentValue: currentValue
                      })
                    } else if (currentValue.id === 'oldConv') {
                      // console.log('une ancienne conv ', currentValue.id)
                      // retour('erreur : ')
                      listChildNodes({
                        messageData: data.messageData, // les données updateata
                        node: currentValue.childNodes // le noeud à parcourir
                      })
                    }
                  },
                  'myThisArg'
                )
              }

              // ajoute le message dans l'historique
              function addMessage (data) {
                console.log('addMessage', data)
                let auteurHisto
                let messageHisto
                let nameAuteurHisto
                let timestampHisto
                let attachmentsHisto
                // console.log('data.currentValue.classList', data.currentValue.classList)
                if (data.currentValue.classList.contains('messageAgent')) {
                  // ajouter cette class en plus pour l'affichage correct dans le chat
                  data.currentValue.classList.add('messageAgent_BO')
                  // console.log('nom Agent', currentValue.firstChild.firstChild.innerHTML)
                  // console.log('message Agent', currentValue.firstChild.lastChild.firstChild.innerHTML)
                  // console.log('timestamp Agent', currentValue.firstChild.childNodes[1].dataset.timestamp)
                  auteurHisto = 'Bot'
                  messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML
                  nameAuteurHisto = data.currentValue.firstChild.firstChild.innerHTML
                  timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp
                } else if (data.currentValue.classList.contains('messageVisiteur')) {
                  // ajouter cette class en plus pour l'affichage correct dans le chat
                  data.currentValue.classList.add('messageVisiteur_BO')
                  // console.log('nom Visiteur', message.data.chatSession)
                  // console.log('message Visiteur', currentValue.lastChild.innerTEXT)
                  auteurHisto = 'Visiteur'
                  messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML
                  nameAuteurHisto = data.messageData.chatSession
                  timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp
                  // une image du bot
                } else if (data.currentValue.classList.contains('botImageAndLabel')) {
                  console.log('Une image', data.currentValue.firstChild.childNodes[2].childNodes[2].childNodes[1].src)
                  // console.log('message Visiteur', currentValue.lastChild.innerTEXT)
                  auteurHisto = 'Bot'
                  messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML
                  nameAuteurHisto = data.currentValue.firstChild.firstChild.innerHTML
                  timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp
                  attachmentsHisto = data.currentValue.firstChild.childNodes[2].childNodes[2].childNodes[1].src
                }

                let messageBot = {
                  'attachments': attachmentsHisto,
                  'auteur': auteurHisto,
                  'chatSession': '0',
                  'message': messageHisto,
                  'nameAuteur': nameAuteurHisto,
                  'timestamp': timestampHisto,
                  'type': data.messageData.messageType,
                  'visiteurId': data.messageData.chatSession,
                  'agentId': data.messageData.WZAgentId
                  // 'histoChatBot': message.data.histoChatBot
                }
                console.log('messageBot', messageBot)
                histoChat.push(messageBot)
              }
              // recupere les infos du nouveau visiteur
              store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT', {
                messageChat: message.data, // les données updateChat
                histoChat: histoChat,
                indexSession: indexSession
              })
            })
            .catch(e => {
              console.error(e)
            })
            // -------------------------------------------
          } else {
            // recupere les infos du nouveau visiteur
            store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT', {
              messageChat: message.data, // les données updateChat
              histoChat: [],
              indexSession: indexSession
            })
          }
        }
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'updateTyping' du server socket.io
     * indication que l'utilisateur ecrit un message
     * @param  {Object} message [message agent]
    */
    socket.on('updateTyping', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_UPDATE_TYPING', {
          messageChat: message.data, // Les données du isTyping
          messageAction: message.action // Les données du isTyping
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'confirmSatisfaction' du server socket.io
     * confirm la satisfaction
     * @param  {Object} message [message agent]
    */
    socket.on('confirmSatisfaction', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        message.data.retour = true
        store.commit('_StoreWatcheeBox/SOCKET_RETOUR_SATISFACTION', {
          messageChat: message.data // Les données du retourner du formulaire de satisfaction
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'noSatisfaction' du server socket.io
     * non satisfaction
     * @param  {Object} message [message agent]
    */
    socket.on('noSatisfaction', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        message.data.retour = false
        store.commit('_StoreWatcheeBox/SOCKET_RETOUR_SATISFACTION', {
          messageChat: message.data // Les données du retourner du formulaire de satisfaction
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'visitorTransfered' du server socket.io
     * visiteur transferé
     * @param  {Object} message [message agent]
    */
    socket.on('visitorTransfered', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'transfere',
          emission: false,
          messageDatas: message.data // Les données du retourner par le serveur de chat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'transfertVisitorWait' du server socket.io
     * visiteur en attente de transfere
     * @param  {Object} message [message agent]
    */
    socket.on('transfertVisitorWait', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'wait',
          emission: true,
          messageDatas: message // Les données du retourner par le serveur de chat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'visitorTransferedOk' du server socket.io
     * visiteur transfere OK
     * @param  {Object} message [message agent]
    */
    socket.on('visitorTransferedOk', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'ok',
          emission: true,
          messageDatas: message.data // Les données du retourner par le serveur de chat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'visitorTransferedNo' du server socket.io
     * visiteur transfere non accepté
     * @param  {Object} message [message agent]
    */
    socket.on('visitorTransferedNo', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'no',
          emission: true,
          messageDatas: message.data // Les données du retourner par le serveur de chat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'visitorTransferedAnnuler' du server socket.io
     * visiteur transfere annulé
     * @param  {Object} message [message agent]
    */
    socket.on('visitorTransferedAnnuler', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'annuler',
          emission: false,
          messageDatas: message.data // Les données du retourner par le serveur de chat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'messageSocialNetwork' du server socket.io
     * reception message des reseaux sociaux
     * @param  {Object} message [message agent]
    */
    socket.on('messageSocialNetwork', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        // console.log('message :', message)
        // si l'agent est online on met à jour la liste des message dans le chat
        if (store.state._StoreWatcheeBox.status === 'online') {
          // recupere les infos du nouveau visiteur
          store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_SOCIAL', {
            messageChat: message.data // les données updateChat
          })
        // ou si l'agent est sur la page message en attentes, on met à jour la liste de messages
        // si le chat est ouvert sur cette conversation
        } else if ((router.app._route.name === 'attente') && store.state._StoreWatcheeBox.allDataVisiteurOpened.visiteurID === message.data.senderID) {
          // recupere les infos du nouveau visiteur
          store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_SOCIAL_OFFLINE', {
            messageChat: message.data // les données updateChat
          })
        } else if ((router.app._route.name === 'contact') && store.state._StoreWatcheeBox.contactOpened.visiteurID === message.data.senderID) {
          // mise à jour de l'historique de chat du contact
          store.commit('_StoreWatcheeBox/SET_ADD_MESSAGE_CONTACT', {
            messageChat: message.data // les données updateChat
          })
        }
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'messengerDeliveryMessage' du server socket.io
     * message facebook délivré
     * @param  {Object} message [message agent]
    */
    socket.on('messengerDeliveryMessage', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_SOCIAL_DELIVRE', {
          messageChat: message.data // les données updateChat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'messengerReadMessage' du server socket.io
     * message facebook lu
     * @param  {Object} message [message agent]
    */
    socket.on('messengerReadMessage', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_SOCIAL_LU', {
          messageChat: message.data // les données updateChat
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'answGeoloc' du server socket.io
     * reponse géolocalisation
     * @param  {Object} message [message agent]
    */
    socket.on('answGeoloc', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_RETURN_GEOLOC', {
          position: message.data // les données
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'reponseCobrowsing' du server socket.io
     * réponse demande cobrowsing
     * @param  {Object} message [message agent]
    */
    socket.on('reponseCobrowsing', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_RETURN_REPONSE_COBROWSING', {
          data: message.data // les données
        })
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcReturnTurnServer' du server socket.io
     * réponse server webrtcReturnTurnServer
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcReturnTurnServer', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_TOKEN_TURN_SERVER', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcOffer' du server socket.io
     * réponse server webrtcOffer
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcOffer', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_PEER_OFFER', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcAnswer' du server socket.io
     * réponse server webrtcAnswer
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcAnswer', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_PEER_ANSWER', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcCandidate' du server socket.io
     * réponse server webrtcCandidate
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcCandidate', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_ICE_CANDIDATE', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcReponseScreensharing' du server socket.io
     * réponse server webrtcReponseScreensharing
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcReponseScreensharing', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_WEBRTC_REPONSE_SCREENSHARING', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'webrtcPeerClose' du server socket.io
     * réponse server webrtcPeerClose
     * @param  {Object} message [message agent]
    */
    socket.on('webrtcPeerClose', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_WEBRTC_CLOSE_SCREENSHARING', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    /**
     * Message de retour 'demandeWebCall' du server socket.io
     * réponse server demandeWebCall
     * @param  {Object} message [message agent]
    */
    socket.on('demandeWebCall', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_DEMANDE_WEBCALL', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })
    /**
     * Message de retour 'closeWebCall' du server socket.io
     * réponse server closeWebCall
     * @param  {Object} message [message agent]
    */
    socket.on('closeWebCall', (message) => {
      if (store) {  // Vérifier que le store est bien disponible
        store.commit('_StoreWatcheeBox/SOCKET_CLOSE_WEBCALL', message)
      } else {
        console.error('❌ Store non disponible dans le plugin WebSocket')
      }
    })

    // pour tester
    socket.on('customEvent', (message) => {
      console.log('📩 Événement reçu :', message)
      Vue.prototype.$emit('customEvent', message) // Émet l'événement globalement
    })
    // Écouter d'autres événements ici...
  }
}



// WEBPACK FOOTER //
// ./src/plugins/socket.js